<template>
  <div class="p-grid">
    <div class="p-col-12">
      <div class="card"> 

        
        
        <div class="p-mb-4 p-d-flex p-jc-between p-toolbar">
          <!-- <Button
            label="New Activity Type"
            icon="pi pi-plus"
            class="p-button-success p-mr-2"
            style="margin-right: 1em"
            @click="openNew"
          /> -->
          <div>
            <span class="p-input-icon-left">
              <i class="pi pi-search" />
              <InputText
                v-model="globalFilter"
                placeholder="Global Search"
                style="margin-right: 0.5em"
                @input="updateSearch"
              />
            </span>
          </div>
        </div>
        
        <historyTable
          :data="activityHisotry"
          :name="'Activity History'"
          :loading="loading"
          :globalFilter="globalFilter"
        />

      </div>
    </div>
  </div>
</template>

<script>
import historyTable from '../../universalComponents/history/historyTable'

export default {
  components: {
    historyTable
  },
  data: () => ({
    globalFilter: '',
  }),
  computed: {
    loading() {
      return this.activityHisotry ? false : true
    },
    activityHisotry() {
      return this.$store.getters['activities/getActivityHistoryForTab']
    }
  },
  created() {
    
    if (this.$route.query.search !== '') {
      this.updateSearch('')
    }
  },
  methods: {
    updateSearch(e) {
      this.$router.push({ query: { search: e } });
    },
  }
}
</script>

<style>

</style>